<template>
  <div class="about">
    <SubTitle subtitle="About Me" description="私について" />
    <Profile leftImage="profile_icon.jpg" :rightText="profileText" name="Matsuo Kousuke" />
    <Profile name="職歴、経験など" :rightText="experienceText" />
  </div>
</template>

<script>
import Profile from "@/components/Profile";

export default {
  name: "About",
  title: "About Me",
  components: {
    Profile
  },
  data: () => ({
    profileText:
      "大阪在住のエンジニアです。<br />" +
      "経験は主にJava/Kotlinの業務系システムです。<br />" +
      "Vue.jsを通じてJavaScriptの理解度を高めたく、作ってみました。<br />" +
      "DevOpsに適応できるよう、AWS等々のクラウド構築への造詣を深めていきます。<br /><br />" +
      "趣味: ダーツ、車、キャンプetc...<br />" +
      "<a href='https://twitter.com/_k_matsuo' target='blank'>Twitter</a>",
    experienceText:
      "<ul type='square'>" +
      "<li style='margin-bottom: 8px'>" +
      "医療機器販売手続簡素化ソリューション（9ヶ月）<br />" +
      "Kotlin or PHP<br />" +
      "FW: Jooby or CakePHP<br />" +
      "DB: MySQL<br />" +
      "Other: Vue.js、AWS（EC2、ElasticBeanstalkをすこし）、CircleCi" +
      "</li>" +
      "<li style='margin-bottom: 8px'>大学向け業務システム （約1年半）<br />" +
      "Java 6 ~ 8<br />" +
      "FW: Java EE + JSF<br />" +
      "DB: DB2" +
      "</li>" +
      "<li style='margin-bottom: 8px'>研修（アドベントカレンダー）（約1ヶ月）<br />" +
      "Java 8<br />" +
      "FW: SpringBoot 1.x<br />" +
      "DB: MySQL<br />" +
      "</li>" +
      "<li style='margin-bottom: 8px'>職業訓練学校（約5ヶ月）<br />" +
      "Java Servlet + JSP<br />" +
      "DB: MySQL<br />" +
      "</li>" +
      "</ul>"
  })
};
</script>